import { takeLatest, takeEvery, all, fork } from "redux-saga/effects";
import { watchUser } from "./userSaga";
import { watchAdminClient } from "./adminClientSaga";
import { watchPlan } from "./servicePlansSaga";
import { watchLead } from "./leadSaga";
import { watchWorker } from "./workerSaga";
import { watchMMYM } from "./mmymSaga";
import { watchVehicle } from "./vehicleSaga";
import { watchLeadSurvey } from "./leadSurveySaga";
import { watchSubUser } from "./subUserSaga";
import { watchSurveyDiary } from "./surveyDiarySaga";
import { watchRole } from "./roleSaga";
import { watchCustomer } from "./customerSaga";
import { watchConfirmation } from "./clientConfirmationSaga";
import { watchDocument } from "./documentSaga";
import { watchInvoice } from "./invoiceSaga";
import { watchPayment } from "./paymentSaga";
import { watchWorkDiary } from "./workDiarySaga";
import { watchFeedback } from "./feedbackSaga";
import { watchCustomerFeedback } from "./customerFeedbackSaga";
import { watchTemplate } from "./templateSaga";
import { watchReferrer } from "./referrerSaga";
import { watchPublic } from "./publicSaga";
import { watchAdminCreation } from "./adminCreationSaga";
import { watchHtmlTemplate } from "./htmlTemplateSaga";
import { watchDashboard } from "./dashboardSaga";
import { watchMaterial } from "./materialSaga";
import { watchAssignWorker } from "./assignWorkerSaga";
import { watchQuickBook } from "./quickBookSaga";
import { watchSubContractor } from "./subContractorSaga";
import { watchSale } from "./saleSaga";
import { watchSignOffTask } from "./signOffTaskSaga";
import { watchComplaint } from "./complaintSaga";
import { watchEmailTemplate } from "./emailTemplateSaga";
import { watchSmsTemplate } from "./smsTemplateSaga";
import { watchSetting } from "./settingSaga";
import { watchReview } from "./reviewSaga";
import { watchStorageSetting } from "./storageSettingSaga";
import { watchStorage } from "./storageSaga";
import { watchContractStorage } from "./contractStorageSaga";
import { watchInventoryCrew } from "./inventoryCrewSaga";

const rootSaga = function* () {
  yield all([
    fork(watchUser),
    fork(watchPlan),
    fork(watchAdminClient),
    fork(watchLead),
    fork(watchWorker),
    fork(watchVehicle),
    fork(watchSubUser),
    fork(watchMMYM),
    fork(watchLeadSurvey),
    fork(watchSurveyDiary),
    fork(watchRole),
    fork(watchCustomer),
    fork(watchConfirmation),
    fork(watchDocument),
    fork(watchPayment),
    fork(watchInvoice),
    fork(watchWorkDiary),
    fork(watchFeedback),
    fork(watchCustomerFeedback),
    fork(watchTemplate),
    fork(watchReferrer),
    fork(watchPublic),
    fork(watchAdminCreation),
    fork(watchHtmlTemplate),
    fork(watchDashboard),
    fork(watchMaterial),
    fork(watchAssignWorker),
    fork(watchQuickBook),
    fork(watchSubContractor),
    fork(watchSale),
    fork(watchSignOffTask),
    fork(watchComplaint),
    fork(watchEmailTemplate),
    fork(watchSmsTemplate),
    fork(watchSetting),
    fork(watchReview),
    fork(watchStorageSetting),
    fork(watchStorage),
    fork(watchContractStorage),
    fork(watchInventoryCrew)
  ]);
};

export default rootSaga;
